import { ReactNode } from "react";
import IconButton from "@mui/material/IconButton";
import { spacing } from "@atlas-int/tokens";
import ControlRow from "@atlas-int/ui/ControlRow";

interface ProductsControlPanelProps {
  /** Exporter location dropdown element */
  exporterDropdown: ReactNode;
  /** Importer location dropdown element */
  importerDropdown: ReactNode;
  /** Called when the swap button is clicked */
  onSwap: () => void;
  /** Icon source for the swap button */
  swapIconSrc?: string;
}

export const ProductsControlPanel = ({
  exporterDropdown,
  importerDropdown,
  onSwap,
  swapIconSrc,
}: ProductsControlPanelProps) => {
  return (
    <>
      <ControlRow label="Exporter" inputWidth="160px" flex maxWidth="275px">
        {exporterDropdown}
      </ControlRow>
      <ControlRow compact>
        <IconButton
          onClick={onSwap}
          aria-label="Swap Importer and Exporter"
          sx={{ padding: "3px" }}
        >
          {swapIconSrc && (
            <img
              style={{ height: spacing[14], width: spacing[14] }}
              src={swapIconSrc}
              alt=""
            />
          )}
        </IconButton>
      </ControlRow>
      <ControlRow label="Importer" inputWidth="160px" flex maxWidth="275px">
        {importerDropdown}
      </ControlRow>
    </>
  );
};
